import { useState } from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

import { useRemoveProductMutation } from '@/apis/extended/productApi';
import { useGetCurrentUserQuery } from '@/apis/extended/userApi';
import { CommonEditIconButton } from '@/components/Common/CommonButton/CommonEditIconButton';
import { CommonRemoveIconButton } from '@/components/Common/CommonButton/CommonRemoveIconButton';
import { EditProductDetailModal } from '@/components/ConfirmModals/EditProductDetailModal';
import { RemoveProductModal } from '@/components/ConfirmModals/RemoveProductModal';
import { ProductBadges } from '@/components/ProductDetail/ProductBadges';
import { formatNumber } from '@/utils/helper';
import { Product } from '@/types/ProductType';

type AgentProductBasicDetailsProps = {
  product: Product;
};

export const AgentProductBasicDetails = ({
  product,
}: AgentProductBasicDetailsProps) => {
  const { data: user } = useGetCurrentUserQuery();

  if (!product || !user) return null;

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="h2">
          {product.price ? `$${formatNumber(product.price)}` : 'N/A'}
        </Typography>
      </Box>
      <Typography variant="h3" sx={{ mt: 2 }}>
        {product.name}
      </Typography>
      <Box
        sx={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', mt: 1 }}
      >
        <ProductBadges product={product} />
      </Box>
      {product.note && (
        <Chip
          sx={{ mt: 1 }}
          variant="outlined"
          color="info"
          label={`Size Note: ${product.note}`}
        />
      )}
      <Typography variant="body1" sx={{ mt: 3 }}>
        {product.description}
      </Typography>
    </Box>
  );
};
